import { useMutation, useQueryClient } from "@tanstack/react-query";
import useCreateAccountHolderNotesMutation from "./useCreateAccountHolderNotesMutation";
import {
  AccountHolder,
  updateWallet,
  UpdateWalletBody,
} from "../../../services/accountService";

export default function useUpdateWalletMutation(accountHolderCode: string) {
  const queryClient = useQueryClient();
  const { mutateAsync: createNote } = useCreateAccountHolderNotesMutation();

  return useMutation<string, Error, UpdateWalletBody>(
    (body) => updateWallet(body),
    {
      async onSuccess(_, updatedWallets) {
        const accountConfigData = queryClient.getQueryData<AccountHolder>([
          "accountConfig",
          accountHolderCode,
        ]);

        const existingRatePlans = [...(accountConfigData?.ratePlans || [])];
        const incomingWallets = (updatedWallets as any)?.ratePlans || [];

        let replacedAny = false;
        const updatedRatePlans = [...existingRatePlans];

        for (const wallet of incomingWallets) {
          if (!wallet?.paymentMethodType) continue;

          const idx = updatedRatePlans.findIndex(
            (rp) => rp.paymentMethodType === wallet.paymentMethodType
          );

          if (idx >= 0) {
            updatedRatePlans[idx] = wallet;
            replacedAny = true;
          } else {
            updatedRatePlans.push(wallet);
          }
        }

        queryClient.setQueryData(["accountConfig", accountHolderCode], {
          ...accountConfigData,
          ratePlans: updatedRatePlans,
        });

        if (incomingWallets?.length) {
          for (const updatedWallet of incomingWallets) {
            if (!updatedWallet?.paymentMethodType) continue;
            await createNote({
              accountHolderCode,
              freeText: `Updated wallet for payment method: ${updatedWallet.paymentMethodType}`,
            });
          }
        }

        queryClient.invalidateQueries(["accountConfig", accountHolderCode]);
      },
    }
  );
}
